import React from 'react';
import PropTypes from 'prop-types';

import { Button, ButtonEnums } from '../../components';

/**
 * ActionButtons
 *
 * Renders a group of labeled buttons based on an array of action objects.
 * Each action includes a label, click handler, and optional disabled state.
 * 
 */

function ActionButtons({ actions, disabled, t }) {
  return (
    <React.Fragment>
      {actions.map((action, index) => (
        <Button
          key={index}
          onClick={action.onClick}
          disabled={disabled || action.disabled}
          type={ButtonEnums.type.secondary}
          size={ButtonEnums.size.small}
          className={`bg-[#702741] ${index > 0 ? 'ml-2' : ''}`}
        >
          {t ? t(action.label) : action.label}
        </Button>
      ))}
    </React.Fragment>
  );
}

ActionButtons.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      disabled: PropTypes.bool,
    })
  ).isRequired,
  disabled: PropTypes.bool,
};

ActionButtons.defaultProps = {
  disabled: false,
};

export default ActionButtons;
